module.exports = __webpack_public_path__ + "img/FPT02.b92051fa.svg";